/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createAccountPrinter',
    message: messages.SUCCESS_CREATE_ACCOUNT_PRINTER,
    method: 'POST',
    path: '/account/:accountId/printer',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_ACCOUNT_PRINTER,
    requestSchema: requestSchemas.accountPrinters.createAccountPrinter,
  },
  {
    action: 'deleteAccountPrinters',
    message: messages.SUCCESS_DELETE_ACCOUNT_PRINTERS,
    method: 'DELETE',
    path: '/account/:accountId/printers',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_ACCOUNT_PRINTER,
    requestSchema: requestSchemas.accountPrinters.deleteAccountPrinters,
  },
  {
    action: 'getAccountPrinters',
    isForApplication: true,
    message: messages.SUCCESS_GET_ACCOUNT_PRINTERS,
    method: 'GET',
    path: '/account/:accountId/printers',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_ACCOUNT_PRINTER,
    requestSchema: requestSchemas.accountPrinters.getAccountPrinters,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'updateAccountPrinterById',
    message: messages.SUCCESS_UPDATE_ACCOUNT_PRINTER_BY_ID,
    method: 'PATCH',
    path: '/account/:accountId/printer/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_ACCOUNT_PRINTER,
    requestSchema: requestSchemas.accountPrinters.updateAccountPrinterById,
  },
];
